/**
 * SIMPLE COMPONENT - Componente Simple
 * Para componentes que se reparan con 1 tap (Techo, Corte, Constitución)
 */

import Component from './Component.js';

export default class SimpleComponent extends Component {
  constructor(scene, config) {
    super(scene, config);
    // Los componentes simples siempre tienen tipo 'simple'
    this.type = 'simple';
  }

  /**
   * Reparar componente simple (1 tap repara todo)
   * @returns {number} Valor de integridad recuperado
   */
  repair() {
    const damageCount = super.repair();
    
    if (damageCount > 0) {
      return this.integrityValue;
    }
    
    return 0;
  }

  /**
   * Renderizar componente (placeholder - se implementará después)
   * @param {number} x - Posición X
   * @param {number} y - Posición Y
   */
  render(x, y) {
    // TODO: Implementar renderizado visual
    console.log(`Renderizando ${this.name} en (${x}, ${y})`);
  }
}
